const leisure = [
    {
        name: "Сидения для отдыха",
        img: "./images/category/сидения для отдыха.png"
        
        
    },
    
];

export default leisure;
 